module.exports = __webpack_public_path__ + "img/image0x4.5809e795.jpg";